import { faInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import './EmptyGraph.css';
import emptyIcon from '../../../../../assets/icons/empty-icon.png';

type EmptyGraphProps = {
  title: string;
  radar?: boolean;
};

export function EmptyGraph({ title, radar }: EmptyGraphProps) {
  const { t } = useTranslation();

  return (
    <div className={`empty_graph ${radar ? 'radar' : ''}`}>
      <div className="empty_graph__header">
        <h3 className="empty_graph__title">{title}</h3>
        <FontAwesomeIcon icon={faInfo} className="icon info_icon" aria-hidden="true" />
      </div>
      <div className="empty_graph__body">
        <img src={emptyIcon} alt="" aria-hidden="true" className="empty_graph__icon" />
        <div className="graph_disabled_text">{t('BC014')}</div>
      </div>
    </div>
  );
}
